module.exports = __webpack_public_path__ + "img/figma.ea6f2755.png";